export default "__VITE_ASSET__BESV9QjE__"